import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

export const Typeform = (props: EmbedProps): string => {
  return Frame({
    src: props.attrs.href,
  });
};

// Add the isMatch function for Typeform
Typeform.isMatch = (href: string): boolean => {
  const urlRegex =
    /^https:\/\/([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)\.typeform\.com\/to\/(.*)$/;

  return urlRegex.test(href);
};
